import {getUrlParams} from '../../utils';

const {abtest = ''} = getUrlParams(window.location.href);
// 是否命中屏效优化
const isScreenOptimization = abtest.includes('108334');

export {
    isScreenOptimization
};